import api from '../api/axios';

export interface LoginCredentials {
  phone: string;
  password: string;
}

export interface Restaurant {
  restaurantId: string;
  name: string;
  phone: string;
  email?: string;
  address?: {
    street: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
  };
}

export interface LoginResponse {
  token: string;
  user: {
    userId: string;
    phone: string;
    restaurantId: string;
    restaurantName: string;
    role?: string;
    subscriptionStatus?: number;
    registrationDate?: string;
    trialDaysRemaining?: number;
  };
  restaurants?: Restaurant[];
  requiresNewPassword?: boolean;
  session?: string;
}

export interface RegisterData {
  phone: string;
  password: string;
  restaurantName: string;
  email?: string;
}

export interface ChangePasswordData {
  phone: string;
  temporaryPassword: string;
  newPassword: string;
  session: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/admin/login', credentials);
    return response.data;
  }

  async changePassword(data: ChangePasswordData): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/admin/change-password', data);
    return response.data;
  }

  async register(data: RegisterData): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/admin/register', data);
    return response.data;
  }

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
  }

  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

const authService = new AuthService();
export default authService;


